import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'swiper/css';
import 'swiper/css/navigation';

function ErpMarcas() {
  const swiperRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(4); // We have 4 logos
  const [isMobile, setIsMobile] = useState(false);

  // Array of ERP logos
  const logos = [
    { id: 1, src: "/assets/erp-marcas-1.svg", alt: "ERP Marca 1" },
    { id: 2, src: "/assets/erp-marcas-2.svg", alt: "ERP Marca 2" },
    { id: 3, src: "/assets/erp-marcas-3.svg", alt: "ERP Marca 3" },
    { id: 4, src: "/assets/erp-marcas-4.svg", alt: "ERP Marca 4" },
  ];

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle slide change
  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.realIndex);
  };

  // Navigate to specific slide
  const goToSlide = (index) => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideTo(index);
    }
  };

  return (
    <div className="w-full bg-[#040118] p-12 lg:py-24">
      <div className="container mx-auto">
        {/* Mobile view with carousel */}
        <div className={`${isMobile ? 'block' : 'hidden'}`}>
          <div className="relative">
            <Swiper
              ref={swiperRef}
              modules={[Navigation, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              loop={false}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              onSlideChange={(swiper) => handleSlideChange(swiper)}
              onInit={(swiper) => {
                setActiveSlide(swiper.realIndex);
              }}
              className="mySwiper px-8"
            >
              {logos.map((logo) => (
                <SwiperSlide key={logo.id}>
                  <div className="flex items-center justify-center h-[80px] px-8">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-20 object-contain"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Mobile navigation controls */}
            <div className="flex justify-center mt-8 gap-4">
              <button
                type="button"
                onClick={() => {
                  const prevIndex = (activeSlide - 1 + totalSlides) % totalSlides;
                  goToSlide(prevIndex);
                }}
              >
                <ChevronLeft className="text-white" />
              </button>
              <div className="flex flex-row gap-3 items-center">
                {logos.map((_, i) => (
                  <div
                    key={i}
                    onClick={() => goToSlide(i)}
                    className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                      activeSlide === i
                        ? 'w-[20px] bg-transparent border border-white'
                        : 'w-[20px] bg-white'
                    }`}
                    aria-label={`Go to slide ${i + 1}`}
                  />
                ))}
              </div>
              <button
                type="button"
                onClick={() => {
                  const nextIndex = (activeSlide + 1) % totalSlides;
                  goToSlide(nextIndex);
                }}
              >
                <ChevronRight className="text-white" />
              </button>
            </div>
          </div>
        </div>

        {/* Desktop view with grid layout */}
        <div className={`${isMobile ? 'hidden' : 'block'}`}>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 lg:gap-24">
            {logos.map((logo) => (
              <div key={logo.id} className="flex items-center justify-center">
                <img 
                  src={logo.src} 
                  alt={logo.alt} 
                  className="h-8 md:h-12 lg:h-16 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErpMarcas;
